import { MenuOutlined } from '@ant-design/icons';
import { useSize } from 'ahooks';
import { Popover, Space } from 'antd';
import React, { useCallback, useMemo, useRef, useState } from 'react';
import FilePaste from '@/assets/images/header/file-paste.react.svg?react';
import UserGroup from '@/assets/images/header/user-group.react.svg?react';
import { MultiApp } from '@/config/context';
import { isInternal } from '@/infrastructure/auth';
import { getParamFromUrl } from '@/infrastructure/history';
import { AppSlot } from '@/presentation/components/app-slot';
import { IssueRecommend } from '@/presentation/components/issue-recomend';
import { ShareButton } from '@/presentation/layouts-pro/header/share';
import { AvatarMenu } from '@/presentation/layouts/header/avatar';
import { TopMenuButton } from '@/presentation/layouts/header/button';
import { Notice } from '@/presentation/layouts/header/notice';
import { stores, useStores } from '@/presentation/store';
import HeaderIcon from './copilot/icons/header-icon.react.svg?react';
import { Helper } from './helper';

// 常量
const DOCS_URL = 'https://docs.bugly.woa.com';
const FORUM_URL = 'https://mk.woa.com/coterie/505';

// 公共函数：打开外部链接
const openUrl = (url: string) => {
  window.open(url, '_blank');
};

export const TopMenu = () => {
  const { hasProduct } = useStores().ProductStore;
  const productId = getParamFromUrl('productId');
  const { setCopilotVisible, copilotChatVisible } = stores.LayoutStore;
  const ref = useRef(null);
  const [popVisible, setPopVisible] = useState(false);

  const size = useSize(ref);

  // 公共函数：打开文档中心
  const handleOpenDocs = useCallback(() => {
    openUrl(DOCS_URL);
    setPopVisible(false);
  }, []);

  // 公共函数：打开论坛
  const handleOpenForum = useCallback(() => {
    openUrl(FORUM_URL);
    setPopVisible(false);
  }, []);

  // 公共函数：切换 Copilot 显示状态
  const handleToggleCopilot = useCallback(() => {
    setCopilotVisible(!copilotChatVisible);
    setPopVisible(false);
  }, [setCopilotVisible, copilotChatVisible]);

  const content = (
    <div>
      <TopMenuButton onClick={handleOpenDocs}>
        <FilePaste />
        <span>文档中心</span>
      </TopMenuButton>
      {!isInternal() && <TopMenuButton onClick={handleOpenForum}>
        <UserGroup />
        <span>论坛</span>
      </TopMenuButton>}
      {productId  && <TopMenuButton onClick={handleToggleCopilot}>
        <HeaderIcon />
        <span>Bugly Copilot</span>
      </TopMenuButton>}
      <Helper ></Helper>
      <ShareButton />
    </div>
  );

  const width = useMemo(() => size?.width ?? 0, [size]);

  return (
    <div ref={ref}>
      {width  > 800 && <Space size={24}>
        <AppSlot apps={[MultiApp.WOA]}>
          {productId && <IssueRecommend />}
        </AppSlot>
        {hasProduct && <Space style={{ marginTop: '15px', minWidth: 259, justifyContent: 'flex-end' }}>
          <TopMenuButton onClick={handleOpenDocs}>
            <FilePaste />
            <span>文档中心</span>
          </TopMenuButton>
          {!isInternal() && <TopMenuButton onClick={handleOpenForum}>
            <UserGroup />
            <span>论坛</span>
          </TopMenuButton>}
          <Notice />
          {/* <CopilotAgentWrapper /> */}
          {productId  && <TopMenuButton onClick={handleToggleCopilot}>
            <HeaderIcon />
            <span>Bugly Copilot</span>
          </TopMenuButton>}
          <Helper ></Helper>
          <ShareButton />
        </Space>}
        <AvatarMenu />
      </Space>}
      {width < 800 && (
        <div>
          <Space size={16}>
            <Popover
              visible={popVisible}
              onVisibleChange={setPopVisible}
              content={content} title="" trigger={['click']} overlayClassName='pop-inner-0'>
              <MenuOutlined style={{ cursor: 'pointer' }} />
            </Popover>
            <AvatarMenu />
          </Space>
        </div>
      )}
    </div>
  );
};
